import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref } from "vue"

import {
  onBeforeRouteUpdate,
  RouteLocationNormalizedLoaded,
  useRoute,
  useRouter,
} from "vue-router";
import {onMounted, reactive, ref, watch} from "vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogButton from "@/shared/ui/SogButton.vue";
import {ProductType} from "@/shared/model/productType";
import Product from "@/shared/model/product";
import ProductPrice from "@/shared/model/productPrice";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import apiStore from "@/modules/Store/api";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import PersonAddressCardComponent from "@/modules/OrganisationStructure/components/PersonAddressCardComponent.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import Insurance, {sortInsuranceByNumber} from "@/shared/model/Insurance";
import SelectInsuranceComponent from "@/modules/ShoppingCart/components/SelectInsuranceComponent.vue";
import SogBadge from "@/shared/ui/SogBadge.vue";
import SelectProductComponent from "@/modules/ShoppingCart/components/SelectProductComponent.vue";
import PremiumComponent from "@/modules/ShoppingCart/components/PremiumComponent.vue";
import ProductPriceComponent from "@/modules/ShoppingCart/components/ProductPriceComponent.vue";
import StoreExportBlankComponent from "@/modules/ShoppingCart/components/StoreExportBlankComponent.vue";
import ExportBlankComponent from "@/modules/ShoppingCart/components/ExportBlankComponent.vue";
import {storeToRefs} from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'editShoppingCartItemComponent',
  setup(__props) {

const _spinner = useSpinner();
const _storeExportBlank = ref<InstanceType<typeof StoreExportBlankComponent> | null>(null)

const _hasKzk = ref(false);
const _hasZoll = ref(false);
const _hasTz = ref(false);
const _hasExportBlank = ref(false);

const _sector = ref("");
const _router = useRouter();
const _page = ref<string | undefined>(undefined);
const _store = ref<Insurance[]>([]);
const _insuranceNumberSearch = ref("");

const _shoppingCartStore = useShoppingCartStore();
const _accountStore = useAccountStore();

const {currentShoppingCart} = storeToRefs(_shoppingCartStore);

/*
const _isInvoiced = computed(()=>{
  const t_invoiceType = ;
  return t_invoiceType!=undefined&&t_invoiceType.indexOf("Invoice")>-1;
})
*/

const _current = ref<{
  baseProducts: Product[];
  productPrices: ProductPrice[];
  shoppingCartItem: ShoppingCartItem;
  baseProductType?: ProductType;
}>({
  baseProducts: [],
  productPrices: [],
  shoppingCartItem: new ShoppingCartItem(),
  baseProductType: undefined,
});

const _eCount = ref<InstanceType<typeof SogNumericTextBox> | null>(null);

const _loadStore = ref(false);
const _search = ref("");
const _lstPerson = reactive<{ Person: Person; Address: Address }[]>([]);

watch(_loadStore, (value) => {
  if (value) {
    _spinner.show();
  } else {
    _spinner.hide();
  }
});


async function onSelectProductType(value: ProductType) {
  await _shoppingCartStore.setProductType(value);
  if (value === ProductType.ExportBlank) {
    await _router.push({path: "add", query: {page: "productprice"}});
  } else {
    await _router.push({path: "add", query: {page: "product"}});
  }
}


async function onAddStore() {
  _current.value.shoppingCartItem.count = _current.value.shoppingCartItem.insurances.length;
  _current.value.shoppingCartItem.grossPrice = _current.value.shoppingCartItem.productPrice?.grossPrice ?? 0;
  await _shoppingCartStore.addItem();
}

async function p_loadStore() {
  _loadStore.value = true;
  try {
    //_storeExportBlank.value = [];
    const price =
      _shoppingCartStore.getCurrentItem().shoppingCartItem.productPrice;
    const lst = await apiStore.listInsurance(
      price,
      price?.grossPrice,
      _insuranceNumberSearch.value
    );
    if (lst) {
      _store.value = sortInsuranceByNumber(
        lst.filter(
          (t) =>
            !_current.value.shoppingCartItem.insurances.some(
              (a) => a.id === t.id
            )
        )
      );
    }
  } finally {
    _loadStore.value = false;
  }
}


async function init(route: RouteLocationNormalizedLoaded) {
  _shoppingCartStore.setSingle(false);
  _spinner.hide();
  _sector.value = route.params.sector as string;
  _page.value = route.query.page as string;
  if (_sector.value === "purchase") {
    if (!_page.value) {
      await _shoppingCartStore.initPurchase();
      _page.value = "producttype";
    }
  } else {
    if (!_page.value) {
      if (!currentShoppingCart.value.personId) {
        _page.value = "person";
      } else {
        _page.value = "producttype";
      }
    }
  }

  _current.value = _shoppingCartStore.getCurrentItem();

  switch (_page.value) {
    case "product":
      if (_current.value.baseProducts.length > 0) {
        break;
      } else {
        await _router.push({path: "add", replace: true});
        return;
      }
    case "productprice":
      if (_current.value.productPrices.length > 0) {
        break;
      } else {
        await _router.push({path: "add", replace: true});
        return;
      }
    case "premium":
      if (_current.value.shoppingCartItem.productPrice) {
        _eCount.value?.focus();
        break;
      } else {
        await _router.push({path: "add", replace: true});
        return;
      }
    case "storeexportblank":
      if (!_current.value.shoppingCartItem.productPrice) {
        await _router.push({path: "add", replace: true});
        return;
      }
      await _storeExportBlank.value?.loadStoreExportBlank();
      break;
    case "exportblank":
      if (!_current.value.shoppingCartItem.productPrice) {
        await _router.push({path: "add", replace: true});
        return;
      }
      break;
    case "store":
      if (!_current.value.shoppingCartItem.productPrice) {
        await _router.push({path: "add", replace: true});
        return;
      }
      await p_loadStore();
      break;
  }

  _hasKzk.value = _shoppingCartStore.hasProductType(ProductType.Kzk);
  _hasZoll.value = _shoppingCartStore.hasProductType(ProductType.Zoll);
  _hasTz.value = _shoppingCartStore.hasProductType(ProductType.Tz);
  _hasExportBlank.value = _shoppingCartStore.hasProductType(
    ProductType.ExportBlank
  );

  /*
    if(sector==="sale") {
      shoppingCart.initSale(personId.value)
    }
  */
}

const _insurancesCount = computed(() => {
  return _current.value.shoppingCartItem.insurances.length;
});

onMounted(async () => {
  const route = useRoute();
  await init(route);
});

onBeforeRouteUpdate(async (to) => {
  await init(to);
});

async function onSearch() {
  const lst = await apiOrganisationStructure.listAddress(
    _accountStore.person?.id ?? "",
    "c+b",
    _search.value
  );
  _lstPerson.length = 0;
  if (lst) {
    _lstPerson.push(...lst);
  }
}

async function onSelectPerson(item: { Person: Person; Address: Address }) {
  await _shoppingCartStore.setSalePerson(item);
  await _router.push({path: "add", query: {page: "producttype"}});
  /*
    copyTo(item.Person,_person)
    copyTo(item.Address,_address)
  */
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, null, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Wählen Sie einen Kontakt aus", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardActions, { "is-toolbar": true }, {
          default: _withCtx(() => [
            _createVNode(SogTextBox, {
              modelValue: _search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_search).value = $event)),
              placeholder: "Name",
              "interval-modified": onSearch
            }, null, 8, ["modelValue"]),
            _createVNode(SogCardActionButton, {
              "mdi-icon": "mdi-magnify",
              style: {"align-self":"flex-end"},
              onClick: onSearch
            })
          ]),
          _: 1
        }),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogFlexRow, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_lstPerson, (item) => {
                  return (_openBlock(), _createBlock(PersonAddressCardComponent, {
                    key: item,
                    person: item.Person,
                    address: item.Address,
                    "allow-select": true,
                    onClick: ($event: any) => (onSelectPerson(item))
                  }, null, 8, ["person", "address", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _page.value === 'person']
    ]),
    _withDirectives(_createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogFlexColumn, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(SogButton, {
                  style: {"height":"80px","padding":"10px"},
                  class: "full-width",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelectProductType(_unref(ProductType).Kzk)))
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Kurzzeitkennzeichen ", -1)
                  ]))]),
                  _: 1
                }, 512), [
                  [_vShow, _hasKzk.value]
                ]),
                _withDirectives(_createVNode(SogButton, {
                  style: {"height":"80px"},
                  class: "full-width",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onSelectProductType(_unref(ProductType).Zoll)))
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Ausfuhrkennzeichen ", -1)
                  ]))]),
                  _: 1
                }, 512), [
                  [_vShow, _hasZoll.value]
                ]),
                _withDirectives(_createVNode(SogButton, {
                  style: {"height":"80px"},
                  class: "full-width",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (onSelectProductType(_unref(ProductType).Tz)))
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Tageszulassung ", -1)
                  ]))]),
                  _: 1
                }, 512), [
                  [_vShow, _hasTz.value]
                ]),
                _withDirectives(_createVNode(SogButton, {
                  style: {"height":"80px"},
                  class: "full-width",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (onSelectProductType(_unref(ProductType).ExportBlank)))
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Ausfuhrversicherungsformulare ", -1)
                  ]))]),
                  _: 1
                }, 512), [
                  [_vShow, _hasExportBlank.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _page.value === 'producttype']
    ]),
    _withDirectives(_createVNode(SelectProductComponent, null, null, 512), [
      [_vShow, _page.value==='product']
    ]),
    _withDirectives(_createVNode(ProductPriceComponent, null, null, 512), [
      [_vShow, _page.value === 'productprice']
    ]),
    _withDirectives(_createVNode(StoreExportBlankComponent, {
      ref_key: "_storeExportBlank",
      ref: _storeExportBlank
    }, null, 512), [
      [_vShow, _page.value === 'storeexportblank']
    ]),
    _withDirectives(_createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, null, {
          SubTitle: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode(" Wählen Sie vorhandene Versicherungskarten aus ", -1)
          ]))]),
          default: _withCtx(() => [
            _cache[12] || (_cache[12] = _createTextVNode(" Versicherungskarten ", -1))
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
              return _createVNode(SogSkeleton, {
                key: index,
                height: "48px"
              })
            }), 64))
          ]),
          _: 1
        }, 512), [
          [_vShow, _loadStore.value]
        ]),
        _withDirectives(_createVNode(SogCardActions, { "is-toolbar": true }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(SogBadge, {
              value: _insurancesCount.value,
              "badge-style": "primary",
              "badge-type": "notification",
              overlap: "true"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(SogCardActionButton, {
                  "mdi-icon": "mdi-cart-arrow-down",
                  tooltip: "In den Einkaufswagen legen",
                  onClick: onAddStore
                }, null, 512), [
                  [_vShow, _insurancesCount.value > 0]
                ])
              ]),
              _: 1
            }, 8, ["value"]), [
              [_vShow, _insurancesCount.value > 0]
            ]),
            _createVNode(SogTextBox, {
              modelValue: _insuranceNumberSearch.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_insuranceNumberSearch).value = $event)),
              placeholder: "Nummer",
              width: "150px",
              "interval-modified": p_loadStore,
              style: {"padding-left":"5px"}
            }, null, 8, ["modelValue"]),
            _createVNode(SogCardActionButton, {
              kind: _unref(SogButtonKind).Search,
              onClick: p_loadStore
            }, null, 8, ["kind"])
          ]),
          _: 1
        }, 512), [
          [_vShow, !_loadStore.value]
        ]),
        _withDirectives(_createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SelectInsuranceComponent, { insurances: _store.value }, null, 8, ["insurances"])
          ]),
          _: 1
        }, 512), [
          [_vShow, !_loadStore.value]
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _page.value === 'store']
    ]),
    _withDirectives(_createVNode(PremiumComponent, null, null, 512), [
      [_vShow, _page.value === 'premium']
    ]),
    _withDirectives(_createVNode(ExportBlankComponent, null, null, 512), [
      [_vShow, _page.value === 'exportblank']
    ])
  ]))
}
}

})